module.exports = __webpack_public_path__ + "whiteyogamat.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteyogamat.png
// module id = 909
// module chunks = 0